import { Badge } from '@op/opds.opux';
import { t } from 'i18next';
import styles from './CoveragePromoElement.module.scss';
import { type CoveragePromo } from 'dto/marketableProduct';

const CoveragePromoElement = ({
  promoElement,
}: {
  promoElement: CoveragePromo;
}) => {
  return (
    <Badge
      data-testid='coveragePromo'
      className={styles.badge}
      badgeContent={t(`coveragePromo.${promoElement}.label`)}
    />
  );
};

export default CoveragePromoElement;
